import type { DisciplineStore } from './interfaces'

export const getters = {
  getDiscipline: (state: DisciplineStore): DisciplineStore['discipline'] => state.discipline,
  hasDiscipline: (state: DisciplineStore): boolean => !!state.discipline,
  getCustomerId: (state: DisciplineStore): number | null => state.discipline?.kid.customer_id ?? null,
  getDetails: (state: DisciplineStore): DisciplineStore['details'] => state.details,
  hasDetails: (state: DisciplineStore): boolean => !!state.details,
  isCustomerGo: (state: DisciplineStore): DisciplineStore['customerGo'] => state.customerGo,
  isCustomerPremium: (state: DisciplineStore): DisciplineStore['customerPremium'] => state.customerPremium,
  getCustomerGoId: (state: DisciplineStore): DisciplineStore['customerGoId'] => state.customerGoId,
  isContextLoading: (state: DisciplineStore): DisciplineStore['contextLoading'] => state.contextLoading,
}
